import { MigrationReport, MigrationReportRow, MigrationReportRunParams } from 'types';

import { api } from './setupApi';

class MaintenanceModel {
  link = '/maintenance';

  reportsLink = `${this.link}/fabric_state_migration_reports`;

  reportFilesLink = `${this.link}/fabric_state_migration_report_files`;

  setIngressName = (ingressName: string) =>
    api.post(`${this.link}/kube_update_ingresses`, { indicator_ingress_name: ingressName }).then(({ data }) => data);

  runMigrationReport = (params: MigrationReportRunParams): Promise<MigrationReport> =>
    api
      .post<Record<'run', MigrationReport>>(`${this.link}/fabric_state_migration_report_run`, params)
      .then(({ data }) => data.run);

  getMigrationReports = (limit = 50): Promise<MigrationReport[]> =>
    api
      .get<{ runs?: MigrationReport[] }>(this.reportsLink, { params: { limit } })
      .then(({ data }) => data.runs ?? []);

  getMigrationReport = (id: string): Promise<MigrationReport> =>
    api.get<Record<'run', MigrationReport>>(`${this.reportsLink}/${id}`).then(({ data }) => data.run);

  getMigrationReportRows = (filename: string): Promise<MigrationReportRow[]> =>
    api
      .get<{ rows?: MigrationReportRow[] }>(`${this.reportFilesLink}/${encodeURIComponent(filename)}`)
      .then(({ data }) => data.rows ?? []);

  downloadMigrationReportCsv = (filename: string): Promise<Blob> =>
    api
      .get<Blob>(`${this.reportFilesLink}/${encodeURIComponent(filename)}`, {
        params: { format: 'csv' },
        responseType: 'blob',
      })
      .then(({ data }) => data);
}

export const maintenanceModel = new MaintenanceModel();
